<template>
	<div
		class="modal fade"
		id="tipmodal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
		ref="modal"
	>
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header modal-header-banner">
					<button
						type="button"
						class="modal-close"
						data-dismiss="modal"
						aria-label="Close"
					>
						<i class="sk-icon-times"></i>
					</button>
					<img src="/images/2k-card-pay.png" alt="Credit Cards" />
				</div>
				<div class="modal-body">
					<div class="modal-title">Ready to Checkout?</div>
					<div class="modal-subtitle">
						Looks like you aren’t logged in to your 2ndKitchen
						account.
					</div>
					<button
						type="button"
						class="button button-outline"
						@click="residentialCheckout"
					>
						Resident Checkout
					</button>
					<div class="sk-divider-wrapper">
						<div class="divider"></div>
						<span class="divider-text">or</span>
						<div class="divider"></div>
					</div>
					<button
						type="button"
						class="button button-outline"
						@click="guestCheckout"
					>
						Guest Checkout
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-subtitle {
	font-size: 14px;
	color: var(--sk-grey3);
	margin-bottom: 20px;
	text-align: center;
}

.button-outline {
	width: 100%;
}

.sk-divider-wrapper {
	margin: 20px 0;
}
</style>

<script>
export default {
	name: "GuestCheckoutModal",
	data: function () {
		return {
			resolve: null
		}
	},
	methods: {
		open(options) {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Guest Checkout Modal Opened"
			})
			$(this.$refs.modal).modal("show")
			this.resolve = options.resolve
		},
		guestCheckout() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Guest Checkout Modal Guest Clicked"
			})
			this.$store.dispatch("markFlag", {
				flag: "isGuestCheckoutActive",
				value: true
			})
			this.close()
		},
		residentialCheckout() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Guest Checkout Modal Resident Clicked"
			})
			this.close()
		},
		consumePromise() {
			if (this.resolve) {
				this.resolve()
				this.resolve = null
			}
		},
		close() {
			$(this.$refs.modal).modal("hide")
		}
	},
	mounted: function () {
		$(this.$refs.modal).on("hidden.bs.modal", () => {
			this.consumePromise()
		})
	}
}
</script>